/**
 * Конфигурация UI
 *
 * Начальные значений устанавливаются при подключении Core во Vue приложение через app.use(PluginCore, options)
 */
export default {

	/**
	 * Имя темы оформления
	 *
	 * В данный момент не используется для загрузки css
	 *
	 * @todo Реализовать загрузки и замену css темы на стороне UI
	 *
	 * @see https://ui.topvisor.com/?path=/docs/core-theme--docs
	 */
	themeName: 'light' as 'light' | 'dark' | string,

	/**
	 * CSS-классы модификаторы для документа страницы
	 *
	 * Могут использоваться компонентами для включения необходимых режимов отображения страницы
	 *
	 * Разные компоненты могут добавлять один и тот же класс, чтобы не было конфликтов каждый компонент управляет только своим классом:
	 * - Ключ - уникальное имя компонента, например в setup: `const uid = Math.random();`
	 * - Значение - класс модификатора
	 */
	documentClassModificators: new Map<string | number, string>(),

	/**
	 * Базовая ширина страницы для отображения ПК / Мобильной версии сайта
	 *
	 * @see Core state isMobile
	 */
	widthForMobile: 900,

	/**
	 * Формат даты, который будет использоваться по умолчанию для вывода даты, как правило, зависит от текущего пользователя
	 */
	dateFormat: 'Y-m-d',

	/**
	 * Валюта, которая будет использоваться по умолчанию, как правило, зависит от текущего пользователя
	 */
	currency: 'USD' as 'RUB' | 'USD' | 'EUR',

	/**
	 * Смещение timezone относительно UTC в минутах
	 * Для Москвы: -180
	 */
	timezoneOffset: new Date().getTimezoneOffset() as number,
};
